export default "__VITE_ASSET__d38c90c7__"